module.exports = __webpack_public_path__ + "img/apps-o.8db63afc.png";